/**
 * Vpo reducer
 *
 * @author Mamontov Andrey, 09/2019
 */
import * as VpoActions from '../actions/vpo';
import { VpoName } from '../../models/vpo.model';
import { VpoAction } from '../actions/vpo';
//
export const getData = (state: VpoState) => state.data;
export const getSelected = (state: VpoState) => state.selected;
export const getLoading = (state: VpoState) => state.loading;
export const getError = (state: VpoState) => state.error;

export interface VpoState {
  data: Array<VpoName>;
  selected: VpoName;
  loading: false;
  error: false;
}

export const initialState: VpoState = {
  data: [],
  selected: null,
  loading: false,
  error: false
};

export function reducer (state = initialState, action: VpoAction): any {
  switch (action.type) {
    case VpoActions.LOAD_ALL: {
      return {
        ...state,
        loading: true,
      };
    }
    case VpoActions.LOAD_SUCCESS: {
      return {
        ...state,
        data: action.payload,
        loading: false,
      };
    }
    case VpoActions.UPDATE_DATA: {
      return {
        ...state,
        selected: action.payload
      };
    }
    case VpoActions.UPDATE_DATA_FAIL: {
      return {
        ...state,
        error: action.payload
      };
    }
    default:
      return state;
  }
}
